import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import SynopsysPolarisMappingForm from "./SynopsysPolarisMappingForm";

function SynopsysPolarisCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "token",
      label: "Access Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={SynopsysPolarisMappingForm}
      initialValue={{ apiEndpoint: 'https://polaris.blackduck.com/api' }}
    />
  );
}

export default forwardRef(SynopsysPolarisCredentialsForm);
